<template>
    <div class="customer-service-popup">
        <div class="float-button" @click="togglePopup">
            <span v-if="!isOpen" class="goutong">
                <span class="gtfont">深度沟通</span>
            </span>
            <i v-else class="el-icon-close"></i>
            <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
        </div>
        <transition name="slide-fade">
            <div v-show="isOpen" class="popup-content">
                <div class="popup-header">
                    <img src="https://oss.sbooip.com/static/www/pc/assets/images/kefus.png" alt="" class="xiaoyang">
                    <h3><span style="margin-right: 8px;">人工坐席</span>
                        <BreathingLight></BreathingLight>连线中 <span class="timetips">（工作日 08:30 ~ 18:00）</span>
                    </h3>
                    <p>亲！留下您的问题，我们会尽快回复</p>
                </div>
                <div class="history">
                    <span class="hisIcon" @click="openHistory"><i class="el-icon-arrow-left"></i>历史对话记录</span>
                    <span class="iconbox">
                        <span style="margin-right: 8px;">团队成员</span>
                        <span class="iconimgbox" v-for="(item, index) in wxDatas" :key="index">
                            <img :src="item.headimgurl" :title="item.nickname" class="usericons" :class="item.p_subscribe == 1?'yandian':'moren'" >
                            <span class="guanli" v-if="item.isAdmin == 1">管理员</span>
                            <!-- <span :class="item.p_subscribe == 1?'yandian':'moren'" ></span> -->
                        </span>
                    </span>
                </div>
                <div class="messages-container" ref="messagesContainer">
                    <!-- 历史对话 -->
                    <div v-for="(message, index) in historyMessages" :key="message.id"
                        :class="['message', message.type]">
                        <div class="message-avatar">
                            <img :src="message.type === 'user' ? message.headimgurl : serviceAvatar">
                        </div>
                        <div class="message-content">
                            <div class="message-meta me" v-if="message.type === 'user'">
                                <span class="time">{{ message.add_date }}</span>
                                <span class="sender" style="margin-left: 8px;">{{ message.nickname }}</span>
                            </div>
                            <div class="message-meta" v-else>
                                <span class="sender">小羊君™微笑泡泡</span>
                                <span class="time">{{ formatTime(message.add_date) }}</span>
                            </div>
                            <div v-if="message.type === 'user'" style="display: flex; justify-content: flex-end;">
                                <img v-if="message && message.content_type == 2"
                                    :src="message && message.content ? ossUrl + message.content : ''"
                                    class="message-image" @click="showImg(ossUrl + message.content)" />
                                <span class="message-text" v-else>{{ message.content }}</span>
                            </div>
                            <div v-else>
                                <img v-if="message && message.content_type == 2"
                                    :src="message && message.content ? ossUrl + message.content : ''"
                                    class="message-image" @click="showImg(ossUrl + message.content)" />
                                <span class="message-text" v-else>{{ message.content }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 实时对话 -->
                    <div v-for="(message, index) in messages" :key="index" :class="['message', message.type]">
                        <div class="message-avatar">
                            <img :src="message.type === 'user' ? message.headimgurl : serviceAvatar">
                        </div>
                        <div class="message-content">
                            <div class="message-meta me" v-if="message.type === 'user'">
                                <span class="time">{{ formatTime(message.time) }}</span>
                                <span class="sender" style="margin-left: 8px;">{{ message.nickname }}</span>
                            </div>
                            <div class="message-meta" v-else>
                                <span class="sender">小羊君™微笑泡泡</span>
                                <span class="time">{{ formatTime(message.time) }}</span>
                            </div>
                            <div v-if="message.type === 'user'" style="display: flex; justify-content: flex-end;">
                                <img v-if="message && message.content_type == 2"
                                        :src="message && message.content ? ossUrl + message.content : ''"
                                    class="message-image" @click="showImg(ossUrl + message.content)" />
                                <span class="message-text" v-else>{{ message.content }}</span>
                            </div>
                            <div v-else>
                                <img v-if="message && message.content_type == 2"
                                        :src="message && message.content ? ossUrl + message.content : ''"
                                    class="message-image" @click="showImg(ossUrl + message.content)" />
                                <span class="message-text" v-else>{{ message.content }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 输入栏 -->
                <div class="input-area">
                    <div>
                        <div class="preview-and-upload">
                            <div class="image-preview">
                                <div v-for="(image, index) in previewImages" :key="index" class="preview-item">
                                    <img :src="image" @click="showImg(image)" />
                                    <span class="delete-icon" @click="deleteImage(index)">&times;</span>
                                </div>
                            </div>
                            <div class="file-upload-box" @click="openFileInput" v-show="previewImages.length == 0">
                                <span>+</span>
                            </div>
                        </div>
                        <input type="file" multiple @change="handleFileChange" accept="image/jpeg,image/png"
                            ref="fileInput" style="display: none;">
                    </div>
                    <div class="emojibox">
                        <emoji-picker @emoji="insert" :search="search">
                            <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }"
                                @click.stop="clickEvent">
                                <i class="iconfont icon-xiaolian"></i>
                            </div>
                            <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                                <div class="zhanshi">
                                    <div>
                                        <div v-for="(emojiGroup, category) in emojis" :key="category">
                                            <!-- <h5>{{ category }}</h5> -->
                                            <div>
                                                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName"
                                                    @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </emoji-picker>
                        <div><i class="iconfont icon-chakantiezihuifu" style="color: #ccc;"></i></div>
                    </div>
                    <textarea v-model="newMessage" placeholder="请输入回复内容...亦可将图片粘贴(ctrl+c)至此" @keyup.enter="sendMessage"
                        @paste="handlePaste" class="message-input" rows="2"></textarea>
                    <button @click="sendMessage"
                        :disabled="!newMessage.trim() && !previewImages.length > 0 || isLoading" class="send-button">
                        发送
                    </button>
                </div>
                <div class="historymsssage" v-show="historysw">
                    <div class="historytop">
                        <div class="popup-header">
                            <h3>历史对话记录<span style="font-size: 12px;"> （{{ totalRow }}）</span></h3>
                        </div>
                        <div class="sercchandpage">
                            <div class="searchbox">
                                <div class="inputbox">
                                    <i class="el-icon-search"></i>
                                    <input type="text" v-model="keyword" placeholder="请输入关键词搜索">
                                    <el-button type="info" size="small" @click=serchHistory>搜索</el-button>
                                </div>
                            </div>
                            <el-pagination small layout="prev, pager, next" @current-change="page"
                                :current-page="currentPage" :page-size="listrow" :total="totalRow">
                            </el-pagination>
                        </div>
                    </div>
                    <div class="msssageboxs" ref="msssageboxs">
                        <!-- 历史对话 -->
                        <div v-for="(message, index) in historyMsg" :key="message.id"
                            :class="['message', message.type]">
                            <div class="message-avatar">
                                <img :src="message.type === 'user' ? message.headimgurl : serviceAvatar">
                            </div>
                            <div class="message-content">
                                <div class="message-meta me" v-if="message.type === 'user'">
                                    <span class="time">{{ message.add_date }}</span>
                                    <span class="sender" style="margin-left: 8px;">{{ message.nickname }}</span>
                                </div>
                                <div class="message-meta" v-else>
                                    <span class="sender">小羊君™微笑泡泡</span>
                                    <span class="time">{{ formatTime(message.add_date) }}</span>
                                </div>
                                <div v-if="message.type === 'user'" style="display: flex; justify-content: flex-end;">
                                    <img v-if="message && message.content_type == 2"
                                            :src="message && message.content ? ossUrl + message.content : ''"
                                        class="message-image" @click="showImg(ossUrl + message.content)" />
                                    <span class="message-text" v-else>{{ message.content }}</span>
                                </div>
                                <div v-else>
                                    <img v-if="message && message.content_type == 2"
                                           :src="message && message.content ? ossUrl + message.content : ''"
                                        class="message-image" @click="showImg(ossUrl + message.content)" />
                                    <span class="message-text" v-else>{{ message.content }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="mask" v-show="mask"></div>
        <div class="previewbox" v-show="previewsw" @click="previewsw = false">
            <img :src="previewUrl" alt="">
        </div>
    </div>
</template>

<script>
import avatar from '@/assets/images/kfus.png';
import axios from 'axios';
import { getWxChatDataAccBefore, getWxChatDataAcc } from '@/api'
import BreathingLight from './BreathingLight.vue';
import EmojiPicker from 'vue-emoji-picker'
export default {
    name: 'CustomerService',
    components: { BreathingLight, EmojiPicker },
    data() {
        return {
            isOpen: false,// 控制客服弹窗是否展开
            messages: [],// 存储所有聊天消息的数组
            historyMessages: [], // 对话框历史记录
            historyMsg: [], //所有历史记录
            newMessage: '',      // 当前正在输入的新消息
            isLoading: false,    // 标识客服是否正在回复（加载中）
            unreadCount: 0,      // 未读消息的数量
            serviceAvatar: avatar,  // 客服头像的URL
            socket: null,        // WebSocket连接实例
            connected: false,    // WebSocket连接是否已建立的状态
            socketId: null,      // 存储WebSocket连接的唯一标识
            ossUrl: 'https://oss.sbooip.com',
            selectedFile: null,
            files: [], // 存储选择的文件
            previewImages: [], // 存储图片的预览链接

            keyword: '',
            currentPage: 1,//当前页
            totalRow: 0,//总行数,
            listrow: 20,
            historysw: false,
            mask: false,
            previewUrl: '',
            previewsw: false,
            search: '',

        }
    },
    computed: {
        ids() {
            let ids = this.wxDatas.map(item => {
                return item.uuid === this.wxData.uuid ? null : item.uuid;
            });
            return ids.filter(id => id !== null);
        }
    },
    created() {
        // 初始化WebSocket
        this.initWebSocket();
        // 获取历史聊天记录
        this.getHistoryMessages()
    },

    beforeDestroy() {
        if (this.socket) {
            this.socket.close(); // 在组件销毁前关闭WebSocket连接
        }
    },
    methods: {
        insert(emoji) {
            this.newMessage += emoji
        },
        showImg(url) {
            this.previewUrl = url
            this.previewsw = true
        },
        // 切换弹窗的显示/隐藏状态
        togglePopup() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.mask = true
                this.unreadCount = 0; // 打开弹窗时，将未读消息数清零
                this.messages = []
                this.historyMessages = []
                this.getHistoryMessages()
            } else {
                this.mask = false
            }
        },
        // 打开关闭历史记录
        openHistory() {
            this.historysw = !this.historysw
            if (this.historysw) {
                this.currentPage = 1
                this.getHistory()
            }
        },
        // 分页函数
        page(page) {
            console.log(page)
            this.currentPage = page
            this.getHistory()
        },
        // 搜索历史记录
        serchHistory() {
            this.currentPage = 1
            this.getHistory()
        },
        // 获取左侧历史记录
        async getHistory() {
            try {
                let params = {}
                params.wxid = this.wxData.id
                params.aid = this.wxData.aid
                params.listrow = this.listrow
                params.keyword = this.keyword
                params.page = this.currentPage
                let req = await getWxChatDataAcc(params)
                console.log(req)
                if (req.code == 200) {
                    this.historyMsg = req.data
                    this.totalRow = Number(req.totalrow)
                    this.$nextTick(() => {
                        const container = this.$refs.msssageboxs;
                        container.scrollTop = 0;
                    })
                }
            } catch (error) {
                console.error(error)
            }
        },
        // 获取对话框历史记录
        async getHistoryMessages() {
            try {
                let params = {}
                params.wxid = this.wxData.id
                params.aid = this.wxData.aid
                let req = await getWxChatDataAccBefore(params)
                console.log(req)
                if (req.code == 200) {
                    this.historyMessages = req.data.sort((a, b) => a.add_time - b.add_time)
                } else {
                    this.messages.push({
                        type: 'service',
                        content: '您好，欢迎咨询，请留下您的问题，我们会尽快回复您。',
                        time: new Date()
                    });
                }
                this.$nextTick(() => {
                    this.scrollToBottom(); // 在DOM更新后，将消息容器滚动到底部
                });
            } catch (error) {
                console.error(error)
            }
        },

        // 打开文件选择框
        openFileInput() {
            this.$refs.fileInput.click()
        },
        // 处理文件选择事件
        handleFileChange(event) {
            const files = event.target.files;
            if (files.length > 0) {
                const file = files[0];
                // console.log(file.size/(1024*1024))
                const size = file.size / (1024 * 1024)
                if (size > 2) {
                    this.$message({ message: '图片不能大于2M', type: 'error', offset: 500, duration: 1500 });
                    return
                }
                if (file.type.indexOf('image') === 0) {
                    // 清空之前选择的文件和预览图
                    this.files = [];
                    this.previewImages = [];
                    this.files.push(file);
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.previewImages.push(e.target.result);
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.$message({ message: '请选择jpg或png格式', type: 'error', offset: 500, duration: 1500 });
                }
            }
        },
        // 剪切板事件
        handlePaste(event) {
            const items = event.clipboardData.items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].kind === 'file' && items[i].type.indexOf('image') === 0) {
                    const file = items[i].getAsFile();
                    // 清空之前选择的文件和预览图
                    this.files = [];
                    this.previewImages = [];
                    this.files.push(file);
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.previewImages.push(e.target.result);
                    };
                    reader.readAsDataURL(file);
                    break; // 只处理第一个图片
                }
            }
        },
        // 删除图片
        deleteImage(index) {
            this.files.splice(index, 1);
            this.previewImages.splice(index, 1);
            // 重置文件输入框，这样可以再次选择相同的文件
            this.$refs.fileInput.value = null;
            this.isDisabled = false
        },
        // 上传图片到服务器
        async uploadImages() {
            if (this.files.length === 0) {
                return
            }
            // 创建图片FormData
            let formData = new FormData()
            for (let i = 0; i < this.files.length; i++) {
                formData.append('images[]', this.files[i])
            }
            // 上传文件到服务器
            try {
                let req = await axios.post('/api/upload/uploadChatImg', formData, { timeout: 60000 })
                if (req.data.state === 'ok') {
                    const fileUrls = req.data.message[0].url;
                    console.log('上传的文件', fileUrls)
                    this.selectedFile = fileUrls
                    this.files = [];
                    this.previewImages = []
                    this.$refs.fileInput.value = '';

                }
            } catch (error) {
                console.error(error)
            }
        },

        // 初始化WebSocket
        initWebSocket() {
            const wsUrl = 'wss://www.sbooip.com/ws/';
            try {
                this.socket = new WebSocket(wsUrl);
                this.socket.onopen = () => {
                    console.log('WebSocket连接已建立');
                    // 发送认证信息，包含从mixin中获取的用户ID
                    this.socket.send(JSON.stringify({
                        type: "auth",
                        wx_id: this.wxData.uuid,
                        nickname: this.wxData.nickname,
                        headimgurl: this.wxData.headimgurl,
                        aid: this.wxData.aid,
                        user_id: 'aaefdde9642b3f48946528704556e019'
                    }));
                    this.connected = true; // 更新连接状态为已连接
                };

                // 接收消息
                this.socket.onmessage = (event) => {
                    const data = JSON.parse(event.data);
                    if (data.type !== 'systems') {
                        console.log('收到WebSocket消息:', data);
                    }
                    if (data.aid == this.wxData.aid) {
                        // 处理客服发送过来的消息
                        if (data.type == 'agent_message') {
                            this.handleIncomingMessage({
                                type: 'service',
                                content: data.content,
                                content_type: data.content_type,
                                nickname: data.nickname,
                                headimgurl: data.headimgurl,
                                time: data.time || new Date().toLocaleTimeString()
                            });
                            // 处理群员发来消息
                        } else if (data.type == 'client_message') {
                            this.handleIncomingMessage({
                                type: 'user',
                                nickname: data.nickname,
                                headimgurl: data.headimgurl,
                                content: data.content,
                                content_type: data.content_type,
                                time: data.time || new Date().toLocaleTimeString()
                            });
                            // 处理系统发送的消息
                        } else if (data.type == 'system') {
                            this.handleIncomingMessage({
                                type: 'system',
                                content: data.msg,
                                time: data.time || new Date().toLocaleTimeString()
                            });
                            // 处理认证成功等状态消息
                        } else if (data.status == 'success') {
                            console.log(data.msg);
                        }
                    }

                };

                // 关闭回调
                this.socket.onclose = () => {
                    console.log('WebSocket连接已关闭');
                    this.connected = false; // 更新连接状态为未连接
                    setTimeout(() => this.initWebSocket(), 50); // 重新开启
                };

                // 连接错误
                this.socket.onerror = (error) => {
                    console.error('WebSocket错误:', error);
                    this.connected = false; // 更新连接状态为未连接
                };
            } catch (error) {
                console.error('WebSocket初始化失败:', error);
            }
        },

        // 处理消息
        handleIncomingMessage(data) {
            const newMessage = {
                type: data.type,
                content: data.content,
                nickname: data.nickname,
                content: data.content,
                content_type: data.content_type,
                headimgurl: data.headimgurl,
                time: data.time || new Date()
            };
            this.messages.push(newMessage); // 将接收到的消息添加到消息列表
            if (!this.isOpen) {
                this.unreadCount++; // 如果弹窗未打开，增加未读消息数量
            } else {
                this.$nextTick(() => {
                    this.scrollToBottom(); // 在DOM更新后，将消息容器滚动到底部
                })
            }
        },

        // 发送消息
        async sendMessage() {
            await this.uploadImages()
            // 如果消息为空或者WebSocket连接未建立，则不发送消息
            if ((!this.newMessage.trim() && !this.selectedFile) || !this.connected) return;
            // 显示在对话框
            // 获取输入框中的消息内容并去除首尾空格
            const messageContent1 = this.newMessage.trim();//文字
            const messageContent2 = this.selectedFile;//图片

            const message1 = {
                type: 'user',
                content: messageContent1,
                content_type: 1,
                nickname: this.wxData.nickname,
                headimgurl: this.wxData.headimgurl,
                time: new Date()
            };//文字
            const message2 = {
                type: 'user',
                content: messageContent2,
                content_type: 2,
                nickname: this.wxData.nickname,
                headimgurl: this.wxData.headimgurl,
                time: new Date()
            };//图片
            if (messageContent2) {
                this.messages.push(message2); // 将发送的消息添加到消息列表
            }
            if (messageContent1) {
                this.messages.push(message1); // 将发送的图片添加到消息
            }
            this.$nextTick(() => {
                console.log('DOM更新后执行')
                this.scrollToBottom()
            })
            this.newMessage = ''; // 清空输入框
            this.selectedFile = null; // 清空选择的文件
            this.isLoading = true; // 设置加载状态，表示等待客服回复

            try {
                // console.log('ids数组', this.ids)
                if (messageContent2) {
                    // 通过WebSocket发送消息，包含消息类型、用户ID和消息内容
                    this.socket.send(JSON.stringify({
                        type: 'message',
                        content_type: 2,
                        wx_id: this.wxData.uuid,
                        aid: this.wxData.aid,
                        nickname: this.wxData.nickname,
                        headimgurl: this.wxData.headimgurl,
                        user_id: 'aaefdde9642b3f48946528704556e019',
                        wx_ids: this.ids,
                        msg_source: 1,
                        content: messageContent2
                    }));
                }
                if (messageContent1) {
                    // 通过WebSocket发送消息，包含消息类型、用户ID和消息内容
                    this.socket.send(JSON.stringify({
                        type: 'message',
                        content_type: 1,
                        wx_id: this.wxData.uuid,
                        aid: this.wxData.aid,
                        nickname: this.wxData.nickname,
                        headimgurl: this.wxData.headimgurl,
                        user_id: 'aaefdde9642b3f48946528704556e019',
                        wx_ids: this.ids,
                        msg_source: 1,
                        content: messageContent1
                    }));
                }
            } catch (error) {
                console.error('发送消息失败:', error);
            } finally {
                this.isLoading = false; // 无论消息发送成功与否，都取消加载状态
            }


        },
        formatTime(time) {
            if (typeof time === 'string') return time; // 如果时间已经是字符串，直接返回
            const hours = time.getHours().toString().padStart(2, '0');
            const minutes = time.getMinutes().toString().padStart(2, '0');
            const seconds = time.getSeconds().toString().padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`; // 格式化时间为HH:mm:ss的格式
        },
        scrollToBottom() {
            const container = this.$refs.messagesContainer;
            if (container) {
                setTimeout(() => {
                    container.scrollTop = container.scrollHeight;
                }, 50);
            }
        }
    }
};
</script>

<style scoped>
/* 客服弹窗主容器样式 */
.customer-service-popup {
    position: fixed;
    bottom: 50px;
    right: 40px;
    z-index: 99999;
}

/* 悬浮按钮样式 */
.float-button {
    position: relative;
    width: 60px;
    height: 60px;
    background-color: #409EFF;
    color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    font-size: 16px;
    z-index: 99999;
}

.goutong {
    width: 100%;
    height: 100%;
    display: inline-block;
    background-image: url('@/assets/images/goutong.png');
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
    line-height: 100%;
    position: relative;
}

.gtfont {
    width: 100%;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    text-align: center;
    color: #333;
    /* color: white; */
    background-color: #F1E63F;
    border-radius: 4px;
}

/* 悬浮按钮悬停效果 */
.float-button:hover {
    background-color: #66b1ff;
    transform: scale(1.05);
}

/* 悬浮按钮图标样式 */
.float-button i {
    font-size: 20px;
}

/* 未读消息标记样式 */
.unread-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #f56c6c;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 弹窗内容样式 */
.popup-content {
    position: absolute;
    bottom: 70px;
    right: 0;
    width: 500px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
    height: 500px;
    box-sizing: border-box;
    border-radius: 0 6px 6px 0;
    z-index: 9999999;
}

/* 弹窗头部样式 */
.popup-header {
    padding: 15px 20px;
    background-color: #409EFF;
    color: white;
}

/* 弹窗标题样式 */
.popup-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

/* 弹窗副标题样式 */
.popup-header p {
    margin: 8px 0 0;
    font-size: 12px;
    opacity: 0.9;
}

/* 消息容器样式 */
.messages-container {
    padding: 15px;
    height: 300px;
    padding-top: 60px;
    /* padding-bottom: 60px; */
    overflow-y: scroll;
    background-color: #f5f7fa;
}

/* 单条消息样式 */
.message {
    display: flex;
    margin-bottom: 15px;
}

/* 消息头像样式 */
.message-avatar {
    margin-right: 10px;
}

/* 消息头像图片样式 */
.message-avatar img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: contain;
}

/* 消息内容区域样式 */
.message-content {
    flex: 1;
    max-width: calc(100% - 46px);
}

/* 消息元信息（发送者和时间）样式 */
.message-meta {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.me {
    justify-content: flex-end;
}

/* 发送者名称样式 */
.sender {
    font-weight: bold;
    font-size: 14px;
    margin-right: 8px;
    color: #999;
}

/* 消息时间样式 */
.time {
    font-size: 12px;
    color: #999;
}

/* 消息文本内容样式 */
.message-text {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
    display: inline-block;
}

/* 用户消息的特殊样式 */
.message.user {
    flex-direction: row-reverse;
}

/* 用户消息头像位置调整 */
.message.user .message-avatar {
    margin-right: 0;
    margin-left: 10px;
}

/* 用户消息内容对齐方式 */
.message.user .message-content {
    align-items: flex-end;
}

/* 用户消息气泡样式 */
.message.user .message-text {
    background-color: #409EFF;
    color: white;
    position: relative;
}

.message.user .message-text::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #409EFF;
    position: absolute;
    top: 5px;
    right: -4px;
}

/* 客服消息气泡样式 */
.message.service .message-text {
    background-color: white;
    color: #333;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    position: relative;
}

.message.service .message-text::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid white;
    position: absolute;
    top: 5px;
    left: -4px;
}

/* 加载状态提示样式 */
.loading {
    text-align: center;
    padding: 10px;
    color: #999;
    font-size: 13px;
}

/* 输入区域样式 */
.input-area {
    padding: 15px;
    border-top: 1px solid #e6e6e6;
    background-color: white;
    display: flex;
    position: relative;
}

/* 消息输入框样式 */
.message-input {
    flex: 1;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    height: 80px;
    resize: none;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
    margin-left: 10px;
}

/* 输入框获取焦点时的样式 */
.message-input:focus {
    border-color: #409EFF;
}

/* 发送按钮样式 */
.send-button {
    margin-left: 10px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background-color: #409EFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

/* 发送按钮悬停效果 */
.send-button:hover {
    background-color: #66b1ff;
}

/* 发送按钮禁用状态样式 */
.send-button:disabled {
    background-color: #c0c4cc;
    cursor: not-allowed;
}

/* 文件上传按钮样式 */
.file-upload-button {
    margin-left: 10px;
    padding: 8px 15px;
    background-color: #409EFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

/* 文件上传按钮悬停效果 */
.file-upload-button:hover {
    background-color: #66b1ff;
}

/* 弹窗过渡动画效果 */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

/* 弹窗进入/离开时的状态 */
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

/* 自定义滚动条样式 */
.messages-container::-webkit-scrollbar {
    width: 6px;
}

.msssageboxs::-webkit-scrollbar {
    width: 6px;
}

/* 滚动条轨道样式 */
.messages-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.msssageboxs::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* 滚动条滑块样式 */
.messages-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.msssageboxs::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

/* 滚动条滑块悬停效果 */
.messages-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 滚动条滑块悬停效果 */
.msssageboxs::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 消息图片样式 */
.message-image {
    max-width: 100px;
    max-height: 100px;
    border-radius: 4px;
    /* cursor: pointer; */
}

.preview-and-upload {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.file-upload-box {
    min-width: 80px;
    height: 80px;
    border: 1px dashed #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: #cccccc;
    cursor: pointer;
    /* margin-left: 10px; */
    flex-shrink: 0;
    border-radius: 4px;
}

.file-upload-box:hover {
    border-color: #999;
    color: #999;
}

.image-preview {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
}

.preview-item {
    position: relative;
    /* margin-right: 10px; */
}

.preview-item img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    border: 1px dashed #ccc;
}

.delete-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
}

.history {
    position: absolute;
    width: 100%;
    background-color: white;
    padding: 8px 20px;
    font-size: 12px;
    cursor: pointer;
    color: darkgray;
    border-bottom: 1px solid rgb(224, 223, 223);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.historymsssage {
    width: 500px;
    height: 500px;
    position: absolute;
    left: -500px;
    top: 0;
    background-color: #f5f7fa;
    border-right: 1px solid rgb(238, 235, 235);
    box-shadow: -10px 2px 10px rgba(0, 0, 0, 0.2);

}

.msssageboxs {
    height: 380px;
    padding: 20px;
    overflow-y: scroll;
}

.historytop {
    position: sticky;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: white;
    border-bottom: 1px solid rgb(224, 223, 223);
}

.sercchandpage {
    text-align: center;
    background-color: white;
}

.inputbox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 95%;
    margin: 0 auto;
    padding: 2px;
    border-radius: 4px;
    border: 1px solid darkgray;
    margin-top: 8px;

}

.inputbox input {
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;
    color: rgb(96, 98, 102);
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    width: 100%;
    outline: none;
    border: none;
    padding: 0px 8px;
    font-size: 14px;
}

.el-icon-search {
    margin-left: 4px;
}

/* 设置 placeholder 的样式 */
.message-input::placeholder {
    color: #d1d4d8;
    font-style: italic;
    line-height: 1.3;
}

.timetips {
    font-size: 13px;
    font-weight: normal;
}

.mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
}

.previewbox {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
        width: 800px;
        height: 800px;
        object-fit: contain;
    }
}

.xiaoyang {
    position: absolute;
    right: 8px;
    top: -30px;
    height: 100px;
}

.usericons {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.hisIcon {
    margin-right: 10px;
}

.iconbox {
    display: flex;
    align-items: center;

}

.iconimgbox {
    display: flex;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-right: 8px;
    position: relative;
}

.guanli {
    width: 100%;
    height: 12px;
    font-size: 8px;
    background-color: red;
    color: white;
    text-align: center;
    line-height: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999999;
}

.emojibox {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 8px;
    justify-content: space-between;
    padding: 8px 0;
    height: 80px;
}

.emojibox div .iconfont {
    font-size: 22px !important;
    cursor: pointer;
}

.zhanshi {
    width: 100%;
    position: absolute;
    left: 0;
    top: -200px;
    z-index: 999999;
    background-color: white;
    cursor: pointer;
    height: 200px;
    line-height: 1.6;
    overflow-y: scroll;
}
.yandian{
   border: 2px solid rgb(4, 190, 4) !important;
}
.moren{
   border: 2px solid red !important;
}
</style>